// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import {
//   RiArrowLeftLine,
//   RiAddLine,
//   RiDeleteBinLine,
//   RiCheckLine,
//   RiCloseLine,
//   RiErrorWarningLine,
//   RiSaveLine,
//   RiInboxLine,
//   RiFileTextLine,
//   RiBankLine,
//   RiPhoneLine,
//   RiCalculatorLine,
//   RiRulerLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { LiaRupeeSignSolid } from "react-icons/lia";

// const BASE_URL = process.env.REACT_APP_API_URL;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const fmt = (n) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// /* ─── Toast ─── */
// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, [onClose]);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button onClick={onClose} className="ml-2 opacity-50 hover:opacity-100">
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const inputCls =
//   "w-full bg-indigo-50/60 border border-indigo-200 rounded-xl px-3 py-2 text-xs text-slate-800 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 transition font-mono";

// const newSizeRow = () => ({
//   id: crypto.randomUUID(),
//   height: "",
//   common: "",
//   width: "",
//   rate: "",
//   // computed (preview)
//   totalHeight: 0,
//   area: 0,
//   subTotal: 0,
//   cgst: 0,
//   sgst: 0,
//   total: 0,
// });

// const calcRow = (row, cgstRate = 2.5, sgstRate = 2.5) => {
//   const h = parseFloat(row.height) || 0;
//   const c = parseFloat(row.common) || 0;
//   const w = parseFloat(row.width) || 0;
//   const r = parseFloat(row.rate) || 0;
//   const totalHeight = Math.round((h + c) * 1000) / 1000;
//   const area = Math.round(totalHeight * w * 100) / 100;
//   const subTotal = Math.round(area * r * 100) / 100;
//   const cgst = Math.round(((subTotal * cgstRate) / 100) * 100) / 100;
//   const sgst = Math.round(((subTotal * sgstRate) / 100) * 100) / 100;
//   const total = Math.round((subTotal + cgst + sgst) * 100) / 100;
//   return { totalHeight, area, subTotal, cgst, sgst, total };
// };

// /* ══════════════════════════════════════════
//    AddSplitSizes  –  Step 1
// ══════════════════════════════════════════ */
// const AddSplitSizes = () => {
//   const navigate = useNavigate();
//   const { id: invoiceId } = useParams();
//   const location = useLocation();
//   const state = location.state || {};

//   const {
//     invoiceNumber = "",
//     subTotal: invoiceSubTotal = 0,
//     billTo,
//     cgstRate: invCgst = 2.5,
//     sgstRate: invSgst = 2.5,
//   } = state;

//   const [billNumber, setBillNumber] = useState("");
//   const [rows, setRows] = useState([newSizeRow()]);
//   const [saving, setSaving] = useState(false);
//   const [autoCalcLoading, setAutoCalcLoading] = useState(false);
//   const [toast, setToast] = useState(null);

//   const notify = (message, type = "success") => setToast({ message, type });

//   // Live-compute each row whenever it changes
//   const computedRows = rows.map((row) => ({
//     ...row,
//     ...calcRow(row, invCgst, invSgst),
//   }));

//   const grandSubTotal = computedRows.reduce((s, r) => s + r.subTotal, 0);
//   const grandCgst = computedRows.reduce((s, r) => s + r.cgst, 0);
//   const grandSgst = computedRows.reduce((s, r) => s + r.sgst, 0);
//   const grandTotal = computedRows.reduce((s, r) => s + r.total, 0);

//   const updateRow = (idx, patch) =>
//     setRows((prev) => prev.map((r, i) => (i === idx ? { ...r, ...patch } : r)));

//   const removeRow = (idx) =>
//     setRows((prev) => prev.filter((_, i) => i !== idx));

//   /* ── Auto-calculate from invoice items ── */
//   const handleAutoCalc = async () => {
//     setAutoCalcLoading(true);
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills/auto-calculate`,
//         { cgstRate: invCgst, sgstRate: invSgst },
//       );
//       const items = res.data?.data || [];
//       if (!items.length) {
//         notify("No size items found on this invoice", "error");
//         return;
//       }
//       setRows(
//         items.map((item) => ({
//           id: crypto.randomUUID(),
//           height: item.height ?? "",
//           common: item.common ?? "",
//           width: item.width ?? "",
//           rate: item.rate ?? "",
//         })),
//       );
//       notify("Size rows auto-filled from invoice items");
//     } catch {
//       notify("Failed to auto-calculate", "error");
//     } finally {
//       setAutoCalcLoading(false);
//     }
//   };

//   /* ── Save Step 1 ── */
//   const handleSave = async () => {
//     if (!billNumber.trim()) {
//       notify("Bill number is required", "error");
//       return;
//     }
//     const invalid = computedRows.some(
//       (r) => !r.height || !r.width || !r.rate || r.subTotal <= 0,
//     );
//     if (invalid) {
//       notify("All rows need valid height, width and rate", "error");
//       return;
//     }

//     const sizeItems = computedRows.map((r) => ({
//       height: parseFloat(r.height),
//       common: parseFloat(r.common) || 0,
//       width: parseFloat(r.width),
//       rate: parseFloat(r.rate),
//     }));

//     setSaving(true);
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills`,
//         {
//           billNumber: billNumber.trim(),
//           sizeItems,
//           cgstRate: invCgst,
//           sgstRate: invSgst,
//         },
//       );
//       const splitBillId = res.data?.data?.splitBillId;
//       notify("Size rows saved! Proceeding to add branches…");
//       setTimeout(() => {
//         navigate(`/admin/create-size-wise-splitbill/${invoiceId}`, {
//           state: {
//             ...state,
//             splitBillId,
//             billNumber: billNumber.trim(),
//             grandSubTotal,
//           },
//         });
//       }, 800);
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to save size rows",
//         "error",
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800">
//       {/* Header */}
//       <header className="bg-white border-b border-indigo-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <button
//               onClick={() => navigate(-1)}
//               className="w-9 h-9 rounded-xl border border-indigo-100 flex items-center justify-center text-slate-500 hover:bg-indigo-50 hover:text-indigo-600 transition"
//             >
//               <RiArrowLeftLine className="w-4 h-4" />
//             </button>
//             <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md shadow-indigo-200">
//               <RiRulerLine className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-indigo-800 tracking-tight">
//                 Size-Wise Split Bill — Step 1
//               </h1>
//               <p className="text-[11px] text-indigo-400 tracking-widest uppercase">
//                 Define Size Rows ·{" "}
//                 <span className="font-bold text-violet-600">
//                   {invoiceNumber}
//                 </span>
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <button
//               onClick={handleAutoCalc}
//               disabled={autoCalcLoading}
//               className="flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-200 transition disabled:opacity-50"
//             >
//               {autoCalcLoading ? (
//                 <Spinner />
//               ) : (
//                 <RiCalculatorLine className="w-4 h-4" />
//               )}
//               Auto-fill from Invoice
//             </button>
//             <button
//               onClick={handleSave}
//               disabled={saving || !billNumber.trim() || rows.length === 0}
//               className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50"
//             >
//               {saving ? <Spinner /> : <RiSaveLine className="w-4 h-4" />}
//               {saving ? "Saving…" : "Save & Continue →"}
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="px-6 py-6 space-y-5 w-full">
//         {/* Info cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//           <div className="bg-white border border-indigo-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-indigo-50 flex items-center justify-center">
//               <RiFileTextLine className="w-4 h-4 text-indigo-600" />
//             </div>
//             <div>
//               <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
//                 Invoice
//               </div>
//               <div className="text-sm font-bold text-indigo-700 font-mono">
//                 {invoiceNumber}
//               </div>
//             </div>
//           </div>
//           <div className="bg-white border border-indigo-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-violet-50 flex items-center justify-center">
//               <LiaRupeeSignSolid className="w-4 h-4 text-violet-600" />
//             </div>
//             <div>
//               <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
//                 Invoice Sub Total
//               </div>
//               <div className="text-sm font-bold text-violet-700 font-mono">
//                 ₹{fmt(invoiceSubTotal)}
//               </div>
//             </div>
//           </div>
//           <div className="bg-white border border-indigo-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center">
//               <RiRulerLine className="w-4 h-4 text-emerald-600" />
//             </div>
//             <div>
//               <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
//                 Size Rows
//               </div>
//               <div className="text-sm font-bold text-emerald-700">
//                 {rows.length} row{rows.length !== 1 ? "s" : ""}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Bill Number */}
//         <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm p-5">
//           <label className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest mb-1.5 block">
//             Bill Number <span className="text-red-400">*</span>
//           </label>
//           <input
//             type="text"
//             value={billNumber}
//             onChange={(e) => setBillNumber(e.target.value)}
//             placeholder="e.g. BILL-0006"
//             className="w-full max-w-xs bg-indigo-50/60 border border-indigo-200 rounded-xl px-3 py-2 text-sm text-slate-800 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 transition font-mono"
//           />
//         </div>

//         {/* Size rows table */}
//         <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3.5 bg-indigo-50/40 border-b border-indigo-100 flex items-center justify-between">
//             <span className="text-xs font-bold text-indigo-700 uppercase tracking-widest">
//               Size Calculation Rows
//             </span>
//             <button
//               onClick={() => setRows((r) => [...r, newSizeRow()])}
//               className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 border border-indigo-200 text-indigo-700 rounded-xl text-xs font-bold hover:bg-indigo-100 transition"
//             >
//               <RiAddLine className="w-3.5 h-3.5" /> Add Row
//             </button>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-indigo-50 bg-slate-50/60">
//                   {[
//                     "#",
//                     "Height",
//                     "Common",
//                     "Total Height",
//                     "Width",
//                     "Area (SQC)",
//                     "Rate (₹)",
//                     "Sub Total",
//                     "CGST",
//                     "SGST",
//                     "Total",
//                     "",
//                   ].map((h) => (
//                     <th
//                       key={h}
//                       className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest whitespace-nowrap"
//                     >
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {computedRows.map((row, idx) => (
//                   <tr
//                     key={row.id}
//                     className="border-b border-slate-50 hover:bg-indigo-50/10 transition"
//                   >
//                     <td className="px-3 py-2 text-xs text-slate-400 font-mono">
//                       {idx + 1}
//                     </td>
//                     <td className="px-2 py-2">
//                       <input
//                         type="number"
//                         value={row.height}
//                         onChange={(e) =>
//                           updateRow(idx, { height: e.target.value })
//                         }
//                         placeholder="0.00"
//                         step="0.001"
//                         min={0}
//                         className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
//                       />
//                     </td>
//                     <td className="px-2 py-2">
//                       <input
//                         type="number"
//                         value={row.common}
//                         onChange={(e) =>
//                           updateRow(idx, { common: e.target.value })
//                         }
//                         placeholder="0.000"
//                         step="0.001"
//                         min={0}
//                         className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
//                       />
//                     </td>
//                     <td className="px-3 py-2 text-xs font-mono text-slate-600 whitespace-nowrap">
//                       <span className="bg-slate-50 border border-slate-200 rounded-lg px-2 py-1">
//                         {row.totalHeight || "—"}
//                       </span>
//                     </td>
//                     <td className="px-2 py-2">
//                       <input
//                         type="number"
//                         value={row.width}
//                         onChange={(e) =>
//                           updateRow(idx, { width: e.target.value })
//                         }
//                         placeholder="0"
//                         step="0.01"
//                         min={0}
//                         className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
//                       />
//                     </td>
//                     <td className="px-3 py-2 text-xs font-mono text-slate-600 whitespace-nowrap">
//                       <span className="bg-slate-50 border border-slate-200 rounded-lg px-2 py-1">
//                         {row.area || "—"}
//                       </span>
//                     </td>
//                     <td className="px-2 py-2">
//                       <input
//                         type="number"
//                         value={row.rate}
//                         onChange={(e) =>
//                           updateRow(idx, { rate: e.target.value })
//                         }
//                         placeholder="0"
//                         step="0.01"
//                         min={0}
//                         className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
//                       />
//                     </td>
//                     <td className="px-3 py-2 whitespace-nowrap">
//                       <span className="inline-flex items-center gap-1 bg-indigo-50 border border-indigo-200 rounded-lg px-2 py-1 font-bold text-indigo-700 text-xs font-mono">
//                         ₹{fmt(row.subTotal)}
//                       </span>
//                     </td>
//                     <td className="px-3 py-2 text-xs font-mono text-slate-500 whitespace-nowrap">
//                       ₹{fmt(row.cgst)}
//                     </td>
//                     <td className="px-3 py-2 text-xs font-mono text-slate-500 whitespace-nowrap">
//                       ₹{fmt(row.sgst)}
//                     </td>
//                     <td className="px-3 py-2 whitespace-nowrap">
//                       <span className="font-extrabold text-indigo-800 font-mono text-sm">
//                         ₹{fmt(row.total)}
//                       </span>
//                     </td>
//                     <td className="px-3 py-2">
//                       <button
//                         onClick={() => removeRow(idx)}
//                         disabled={rows.length === 1}
//                         className="w-7 h-7 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition disabled:opacity-30 disabled:cursor-not-allowed"
//                       >
//                         <RiDeleteBinLine className="w-3.5 h-3.5" />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot>
//                 <tr className="bg-indigo-50/60 border-t-2 border-indigo-100">
//                   <td
//                     colSpan={7}
//                     className="px-3 py-3 text-xs font-bold text-indigo-700 uppercase tracking-widest"
//                   >
//                     Grand Total ({rows.length} row{rows.length !== 1 ? "s" : ""}
//                     )
//                   </td>
//                   <td className="px-3 py-3 text-xs font-bold font-mono text-slate-800">
//                     ₹{fmt(grandSubTotal)}
//                   </td>
//                   <td className="px-3 py-3 text-xs font-bold font-mono text-slate-700">
//                     ₹{fmt(grandCgst)}
//                   </td>
//                   <td className="px-3 py-3 text-xs font-bold font-mono text-slate-700">
//                     ₹{fmt(grandSgst)}
//                   </td>
//                   <td className="px-3 py-3">
//                     <span className="font-extrabold text-indigo-800 font-mono text-base">
//                       ₹{fmt(grandTotal)}
//                     </span>
//                   </td>
//                   <td />
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         </div>

//         {/* Add row button */}
//         <button
//           onClick={() => setRows((r) => [...r, newSizeRow()])}
//           className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-indigo-200 text-indigo-500 rounded-2xl text-sm font-semibold hover:border-indigo-400 hover:bg-indigo-50/50 transition"
//         >
//           <RiAddLine className="w-4 h-4" /> Add Size Row
//         </button>

//         {/* Footer actions */}
//         <div className="flex items-center justify-between gap-4 flex-wrap pt-2">
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center gap-2 px-5 py-2.5 border border-slate-200 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-50 transition"
//           >
//             <RiArrowLeftLine className="w-4 h-4" /> Back
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving || !billNumber.trim() || rows.length === 0}
//             className="flex items-center gap-2 px-6 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {saving ? <Spinner /> : <RiSaveLine className="w-4 h-4" />}
//             {saving ? "Saving…" : "Save & Continue →"}
//           </button>
//         </div>
//       </div>

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// };

// export default AddSplitSizes;

import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import {
  RiArrowLeftLine,
  RiAddLine,
  RiDeleteBinLine,
  RiCheckLine,
  RiCloseLine,
  RiErrorWarningLine,
  RiSaveLine,
  RiFileTextLine,
  RiCalculatorLine,
  RiRulerLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { LiaRupeeSignSolid } from "react-icons/lia";

const BASE_URL = process.env.REACT_APP_API_URL;

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/* ─── Toast ─── */
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button onClick={onClose} className="ml-2 opacity-50 hover:opacity-100">
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const newSizeRow = () => ({
  id: crypto.randomUUID(),
  height: "",
  common: "",
  width: "",
  rate: "",
  totalHeight: 0,
  area: 0,
  subTotal: 0,
  cgst: 0,
  sgst: 0,
  total: 0,
});

const calcRow = (row, cgstRate = 2.5, sgstRate = 2.5) => {
  const h = parseFloat(row.height) || 0;
  const c = parseFloat(row.common) || 0;
  const w = parseFloat(row.width) || 0;
  const r = parseFloat(row.rate) || 0;
  const totalHeight = Math.round((h + c) * 1000) / 1000;
  const area = Math.round(totalHeight * w * 100) / 100;
  const subTotal = Math.round(area * r * 100) / 100;
  const cgst = Math.round(((subTotal * cgstRate) / 100) * 100) / 100;
  const sgst = Math.round(((subTotal * sgstRate) / 100) * 100) / 100;
  const total = Math.round((subTotal + cgst + sgst) * 100) / 100;
  return { totalHeight, area, subTotal, cgst, sgst, total };
};

/* ══════════════════════════════════════════
   AddSplitSizes  –  Step 1
══════════════════════════════════════════ */
const AddSplitSizes = () => {
  const navigate = useNavigate();
  const { id: invoiceId } = useParams();
  const location = useLocation();
  const state = location.state || {};

  const {
    invoiceNumber = "",
    subTotal: invoiceSubTotal = 0,
    cgstRate: invCgst = 2.5,
    sgstRate: invSgst = 2.5,
  } = state;

  const [billNumber, setBillNumber] = useState("");
  const [rows, setRows] = useState([newSizeRow()]);
  const [saving, setSaving] = useState(false);
  const [autoCalcLoading, setAutoCalcLoading] = useState(false);
  const [toast, setToast] = useState(null);

  // Existing bill check
  const [existingBill, setExistingBill] = useState(null);
  const [checkingExisting, setCheckingExisting] = useState(true);

  const notify = (message, type = "success") => setToast({ message, type });

  /* ── Check for existing size-wise split bill on mount ── */
  useEffect(() => {
    if (!invoiceId) {
      setCheckingExisting(false);
      return;
    }
    axios
      .get(`${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills`)
      .then((res) => {
        const bills = res.data?.data?.splitBills || [];
        if (bills.length > 0) {
          setExistingBill(bills[0]);
        }
      })
      .catch(() => {})
      .finally(() => setCheckingExisting(false));
  }, [invoiceId]);

  // Live-compute each row whenever it changes
  const computedRows = rows.map((row) => ({
    ...row,
    ...calcRow(row, invCgst, invSgst),
  }));

  const grandSubTotal = computedRows.reduce((s, r) => s + r.subTotal, 0);
  const grandCgst = computedRows.reduce((s, r) => s + r.cgst, 0);
  const grandSgst = computedRows.reduce((s, r) => s + r.sgst, 0);
  const grandTotal = computedRows.reduce((s, r) => s + r.total, 0);

  const updateRow = (idx, patch) =>
    setRows((prev) => prev.map((r, i) => (i === idx ? { ...r, ...patch } : r)));

  const removeRow = (idx) =>
    setRows((prev) => prev.filter((_, i) => i !== idx));

  /* ── Auto-calculate from invoice items ── */
  const handleAutoCalc = async () => {
    setAutoCalcLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills/auto-calculate`,
        { cgstRate: invCgst, sgstRate: invSgst },
      );
      const items = res.data?.data || [];
      if (!items.length) {
        notify("No size items found on this invoice", "error");
        return;
      }
      setRows(
        items.map((item) => ({
          id: crypto.randomUUID(),
          height: item.height ?? "",
          common: item.common ?? "",
          width: item.width ?? "",
          rate: item.rate ?? "",
        })),
      );
      notify("Size rows auto-filled from invoice items");
    } catch {
      notify("Failed to auto-calculate", "error");
    } finally {
      setAutoCalcLoading(false);
    }
  };

  /* ── Save Step 1 ── */
  const handleSave = async () => {
    if (!billNumber.trim()) {
      notify("Bill number is required", "error");
      return;
    }
    const invalid = computedRows.some(
      (r) => !r.height || !r.width || !r.rate || r.subTotal <= 0,
    );
    if (invalid) {
      notify("All rows need valid height, width and rate", "error");
      return;
    }

    const sizeItems = computedRows.map((r) => ({
      height: parseFloat(r.height),
      common: parseFloat(r.common) || 0,
      width: parseFloat(r.width),
      rate: parseFloat(r.rate),
    }));

    setSaving(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills`,
        {
          billNumber: billNumber.trim(),
          sizeItems,
          cgstRate: invCgst,
          sgstRate: invSgst,
        },
      );
      const splitBillId = res.data?.data?.splitBillId;
      notify("Size rows saved! Proceeding to add branches…");
      setTimeout(() => {
        navigate(`/admin/create-size-wise-splitbill/${invoiceId}`, {
          state: {
            ...state,
            splitBillId,
            billNumber: billNumber.trim(),
            grandSubTotal,
          },
        });
      }, 800);
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to save size rows",
        "error",
      );
    } finally {
      setSaving(false);
    }
  };

  /* ── Loading state ── */
  if (checkingExisting) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-indigo-400">
          <Spinner className="w-10 h-10" />
          <span className="text-sm font-medium">Checking existing bills…</span>
        </div>
      </div>
    );
  }

  /* ── Existing bill found — block creation, offer edit ── */
  if (existingBill) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm p-8 max-w-md w-full mx-4 flex flex-col items-center gap-5 text-center">
          <div className="w-12 h-12 rounded-xl bg-indigo-100 flex items-center justify-center">
            <RiRulerLine className="w-6 h-6 text-indigo-600" />
          </div>
          <div>
            <h2 className="text-base font-bold text-indigo-800 mb-1">
              Size-wise split bill already exists
            </h2>
            <p className="text-sm text-slate-500">
              Bill{" "}
              <span className="font-mono font-bold text-indigo-600">
                {existingBill.billNumber}
              </span>{" "}
              is already attached to this invoice. Only one size-wise split bill
              is allowed per invoice.
            </p>
          </div>
          <div className="flex flex-col gap-3 w-full">
            <button
              onClick={() =>
                navigate(`/admin/create-size-wise-splitbill/${invoiceId}`, {
                  state: {
                    ...state,
                    splitBillId: existingBill._id,
                    billNumber: existingBill.billNumber,
                    grandSubTotal: existingBill.grandSubTotal,
                  },
                })
              }
              className="w-full flex items-center justify-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold hover:bg-indigo-700 transition shadow-md shadow-indigo-200"
            >
              <RiRulerLine className="w-4 h-4" /> Edit Branches (Step 2)
            </button>
            <button
              onClick={() => navigate(-1)}
              className="w-full flex items-center justify-center gap-2 px-5 py-2.5 border border-slate-200 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-50 transition"
            >
              <RiArrowLeftLine className="w-4 h-4" /> Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  /* ── Main form (no existing bill) ── */
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <header className="bg-white border-b border-indigo-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 rounded-xl border border-indigo-100 flex items-center justify-center text-slate-500 hover:bg-indigo-50 hover:text-indigo-600 transition"
            >
              <RiArrowLeftLine className="w-4 h-4" />
            </button>
            <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md shadow-indigo-200">
              <RiRulerLine className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-indigo-800 tracking-tight">
                Size-Wise Split Bill — Step 1
              </h1>
              <p className="text-[11px] text-indigo-400 tracking-widest uppercase">
                Define Size Rows ·{" "}
                <span className="font-bold text-violet-600">
                  {invoiceNumber}
                </span>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={handleAutoCalc}
              disabled={autoCalcLoading}
              className="flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-200 transition disabled:opacity-50"
            >
              {autoCalcLoading ? (
                <Spinner />
              ) : (
                <RiCalculatorLine className="w-4 h-4" />
              )}
              Auto-fill from Invoice
            </button>
            <button
              onClick={handleSave}
              disabled={saving || !billNumber.trim() || rows.length === 0}
              className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50"
            >
              {saving ? <Spinner /> : <RiSaveLine className="w-4 h-4" />}
              {saving ? "Saving…" : "Save & Continue →"}
            </button>
          </div>
        </div>
      </header>

      <div className="px-6 py-6 space-y-5 w-full">
        {/* Info cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-white border border-indigo-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-indigo-50 flex items-center justify-center">
              <RiFileTextLine className="w-4 h-4 text-indigo-600" />
            </div>
            <div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
                Invoice
              </div>
              <div className="text-sm font-bold text-indigo-700 font-mono">
                {invoiceNumber}
              </div>
            </div>
          </div>
          <div className="bg-white border border-indigo-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-violet-50 flex items-center justify-center">
              <LiaRupeeSignSolid className="w-4 h-4 text-violet-600" />
            </div>
            <div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
                Invoice Sub Total
              </div>
              <div className="text-sm font-bold text-violet-700 font-mono">
                ₹{fmt(invoiceSubTotal)}
              </div>
            </div>
          </div>
          <div className="bg-white border border-indigo-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center">
              <RiRulerLine className="w-4 h-4 text-emerald-600" />
            </div>
            <div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
                Size Rows
              </div>
              <div className="text-sm font-bold text-emerald-700">
                {rows.length} row{rows.length !== 1 ? "s" : ""}
              </div>
            </div>
          </div>
        </div>

        {/* Bill Number */}
        <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm p-5">
          <label className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest mb-1.5 block">
            Bill Number <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={billNumber}
            onChange={(e) => setBillNumber(e.target.value)}
            placeholder="e.g. BILL-0006"
            className="w-full max-w-xs bg-indigo-50/60 border border-indigo-200 rounded-xl px-3 py-2 text-sm text-slate-800 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 transition font-mono"
          />
        </div>

        {/* Size rows table */}
        <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3.5 bg-indigo-50/40 border-b border-indigo-100 flex items-center justify-between">
            <span className="text-xs font-bold text-indigo-700 uppercase tracking-widest">
              Size Calculation Rows
            </span>
            <button
              onClick={() => setRows((r) => [...r, newSizeRow()])}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 border border-indigo-200 text-indigo-700 rounded-xl text-xs font-bold hover:bg-indigo-100 transition"
            >
              <RiAddLine className="w-3.5 h-3.5" /> Add Row
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-indigo-50 bg-slate-50/60">
                  {[
                    "#",
                    "Height",
                    "Common",
                    "Total Height",
                    "Width",
                    "Area (SQC)",
                    "Rate (₹)",
                    "Sub Total",
                    "CGST",
                    "SGST",
                    "Total",
                    "",
                  ].map((h) => (
                    <th
                      key={h}
                      className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest whitespace-nowrap"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {computedRows.map((row, idx) => (
                  <tr
                    key={row.id}
                    className="border-b border-slate-50 hover:bg-indigo-50/10 transition"
                  >
                    <td className="px-3 py-2 text-xs text-slate-400 font-mono">
                      {idx + 1}
                    </td>
                    <td className="px-2 py-2">
                      <input
                        type="number"
                        value={row.height}
                        onChange={(e) =>
                          updateRow(idx, { height: e.target.value })
                        }
                        placeholder="0.00"
                        step="0.001"
                        min={0}
                        className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
                      />
                    </td>
                    <td className="px-2 py-2">
                      <input
                        type="number"
                        value={row.common}
                        onChange={(e) =>
                          updateRow(idx, { common: e.target.value })
                        }
                        placeholder="0.000"
                        step="0.001"
                        min={0}
                        className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
                      />
                    </td>
                    <td className="px-3 py-2 text-xs font-mono text-slate-600 whitespace-nowrap">
                      <span className="bg-slate-50 border border-slate-200 rounded-lg px-2 py-1">
                        {row.totalHeight || "—"}
                      </span>
                    </td>
                    <td className="px-2 py-2">
                      <input
                        type="number"
                        value={row.width}
                        onChange={(e) =>
                          updateRow(idx, { width: e.target.value })
                        }
                        placeholder="0"
                        step="0.01"
                        min={0}
                        className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
                      />
                    </td>
                    <td className="px-3 py-2 text-xs font-mono text-slate-600 whitespace-nowrap">
                      <span className="bg-slate-50 border border-slate-200 rounded-lg px-2 py-1">
                        {row.area || "—"}
                      </span>
                    </td>
                    <td className="px-2 py-2">
                      <input
                        type="number"
                        value={row.rate}
                        onChange={(e) =>
                          updateRow(idx, { rate: e.target.value })
                        }
                        placeholder="0"
                        step="0.01"
                        min={0}
                        className="w-20 px-2 py-1.5 bg-indigo-50/60 border border-indigo-200 rounded-lg text-xs font-mono text-slate-700 placeholder-indigo-300 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition"
                      />
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      <span className="inline-flex items-center gap-1 bg-indigo-50 border border-indigo-200 rounded-lg px-2 py-1 font-bold text-indigo-700 text-xs font-mono">
                        ₹{fmt(row.subTotal)}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-xs font-mono text-slate-500 whitespace-nowrap">
                      ₹{fmt(row.cgst)}
                    </td>
                    <td className="px-3 py-2 text-xs font-mono text-slate-500 whitespace-nowrap">
                      ₹{fmt(row.sgst)}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      <span className="font-extrabold text-indigo-800 font-mono text-sm">
                        ₹{fmt(row.total)}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <button
                        onClick={() => removeRow(idx)}
                        disabled={rows.length === 1}
                        className="w-7 h-7 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition disabled:opacity-30 disabled:cursor-not-allowed"
                      >
                        <RiDeleteBinLine className="w-3.5 h-3.5" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-indigo-50/60 border-t-2 border-indigo-100">
                  <td
                    colSpan={7}
                    className="px-3 py-3 text-xs font-bold text-indigo-700 uppercase tracking-widest"
                  >
                    Grand Total ({rows.length} row{rows.length !== 1 ? "s" : ""}
                    )
                  </td>
                  <td className="px-3 py-3 text-xs font-bold font-mono text-slate-800">
                    ₹{fmt(grandSubTotal)}
                  </td>
                  <td className="px-3 py-3 text-xs font-bold font-mono text-slate-700">
                    ₹{fmt(grandCgst)}
                  </td>
                  <td className="px-3 py-3 text-xs font-bold font-mono text-slate-700">
                    ₹{fmt(grandSgst)}
                  </td>
                  <td className="px-3 py-3">
                    <span className="font-extrabold text-indigo-800 font-mono text-base">
                      ₹{fmt(grandTotal)}
                    </span>
                  </td>
                  <td />
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Add row button */}
        <button
          onClick={() => setRows((r) => [...r, newSizeRow()])}
          className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-indigo-200 text-indigo-500 rounded-2xl text-sm font-semibold hover:border-indigo-400 hover:bg-indigo-50/50 transition"
        >
          <RiAddLine className="w-4 h-4" /> Add Size Row
        </button>

        {/* Footer actions */}
        <div className="flex items-center justify-between gap-4 flex-wrap pt-2">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2.5 border border-slate-200 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-50 transition"
          >
            <RiArrowLeftLine className="w-4 h-4" /> Back
          </button>
          <button
            onClick={handleSave}
            disabled={saving || !billNumber.trim() || rows.length === 0}
            className="flex items-center gap-2 px-6 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? <Spinner /> : <RiSaveLine className="w-4 h-4" />}
            {saving ? "Saving…" : "Save & Continue →"}
          </button>
        </div>
      </div>

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default AddSplitSizes;
